<template>
  <b-container>
    <b-row class="justify-content-end">
      <b-button variant="info" class="mt-3 mx-3" @click="goToCreateGroup">افزودن سطح دسترسی جدید</b-button>
    </b-row>
    <b-row class="justify-content-end">
      <p class="text-right rtl mt-3 mx-3">
        نکات مهم:<br />
        <ul>
          <li>امکان حذف گروه های پیش فرض: <strong>اپراتور</strong> ، <strong>ادمین</strong> و <strong>عمومی</strong> وجود ندارد</li>
          <li>پس از حذف گروه دلخواه غیر پیش فرض، سطح دسترسی کاربرانی که در آن گروه بودند به عمومی تغییر میابد</li>
        </ul>
      </p>
    </b-row>
    <b-row class="justify-content-end mt-4">
      <b-col md="1">
        <b-button pill variant="outline-info" size="sm" @click="searchGroups" class="w-100"><b-icon icon="search" class="m-1"></b-icon></b-button>
      </b-col>
      <b-col v-show="searchTerm.length > 0" md="1">
        <b-button pill size="sm" variant="outline-secondary" @click="searchTerm = ''; fetchGroupsData()" class="w-100"><b-icon icon="x" class="m-1"></b-icon></b-button>
      </b-col>
      <b-col md="5">
        <b-form-input type="search" class="w-100 rtl" v-model="searchTerm" placeholder="جستجو در نام و کلید"></b-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="mx-auto m-3" v-show="nothingToShow">
        <p class="text-center text-secondary rtl">هیچ سطح دسترسی ای یافت نشد <b-button pill variant="outline-secondary" size="sm" @click="goToCreateGroup">افزودن جدید</b-button></p>
      </b-col>
      <b-col md="12" class="mx-auto m-3" v-show="!nothingToShow">
        <b-card class="w-100 shadow text-right">
          <b-table striped hover :items="groupTable.items" :fields="groupTable.fields" 
            id="table_reference" :busy="loading" caption-top>
            <template #table-caption>لیست سطوح دسترسی</template>
            <template #table-busy>
              <div class="text-center text-info my-2">
                در حال دریافت اطلاعات
                <b-spinner class="align-middle m-1" small></b-spinner>
              </div>
            </template>
            <template #cell(actions)="row">
              <b-button variant="outline-info" size="sm" @click="editGroupRow(row)" class="m-1"><b-icon icon="pencil" class="m-1"></b-icon>ویرایش</b-button>
              <b-button variant="outline-danger" size="sm" @click="removeGroupRow(row)"><b-icon icon="trash" class="m-1"></b-icon>حذف</b-button>
            </template>
          </b-table>
          <b-pagination
            v-show="pagination.count != 0"
            v-model="pagination.page"
            :total-rows="pagination.count"
            :per-page="pagination.limit"
            class="mt-3"
            align="center"
            aria-controls="table_reference"
            @page-click="clickOnPage"
          ></b-pagination>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import _ from 'lodash'

export default {
  name: 'AccessLevelsTable',
  data: () => ({
    loading: false,
    nothingToShow: false,
    groups: [],
    groupTable: {
      fields: [
        {
          key: "name",
          label: "کلید"
        },
        {
          key: "slog",
          label: "نام"
        },
        {
          key: "actions",
          label: "عملیات"
        }
      ].reverse(),
      items: []
    },
    searchTerm: '',
    pagination: {
      count: 0,
      page: 1,
      limit: 20
    }
  }),
  created() {
    this.fetchGroupsData()
  },
  methods: {
    fetchGroupsData(searchTerm) {
      this.loading = true
      let params = {
        limit: this.pagination.limit,
        page: this.pagination.page
      }
      if (searchTerm && typeof searchTerm == 'string' && searchTerm.length > 0) {
        params["q"] = searchTerm
      }
      this.$axios.get('/privacy/groups', {
        params
      }).then((response) => {
        const body = response.data

        if (body.count == 0) {
          this.nothingToShow = true
        } else {
          this.groups = body.data
          this.groupTable.items = _.map(body.data, (o) => {
            return {
              name: o.name,
              slog: o.slog
            }
          })
          this.pagination.count = body.count
        }
      }).catch((err) => {
        this.$bvToast.toast(err.text, { variant: 'danger', title: 'خطا' })
      }).finally(() => {
        this.loading = false
      })
    },
    searchGroups() {
      this.fetchGroupsData(this.searchTerm)
    },
    goToCreateGroup() {
      this.$router.push({ name: 'CreateAccessLevel' })
    },
    editGroupRow(row) {
      let group = this.groups[row.index]
      this.$router.push({ name: 'EditAccessLevel', params: { group_id: group._id }})
    },
    removeGroupRow(row) {
      if (["public", "operator", "admin"].includes(row.item.name)) {
        this.$bvToast.toast('امکان حذف گروه پیش فرض وجود ندارد', { variant: 'danger', title: 'خطا' })
        return
      }
      this.$bvModal.msgBoxConfirm('آیا از حذف '+row.item.slog+' اطمینان دارید؟', {
          title: 'توجه',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'بله',
          cancelTitle: 'بستن',
          bodyClass: 'text-right',
          headerClass: 'text-danger',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(result => {
          if (result) {
            this.loading = true
            this.$axios.delete('/privacy/groups/'+this.groups[row.index]._id).then(() => {
              this.$bvToast.toast('سطح دسترسی با موفقیت حذف شد', { variant: 'success', title: 'هورا' })
            }).catch(err => {
              this.$bvToast.toast(err.text, { variant: 'danger', title: 'خطا' })
            }).finally(() => {
              this.loading = false
            })
          }
        })
    },
    clickOnPage(bvEvent, page) {
      bvEvent.preventDefault()
      this.pagination.page = page
      this.fetchGroupsData()
    }
  }
}
</script>